import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "18", x2: "22", y1: "2", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7.5 20.5 19 9l-4-4L3.5 16.5 2 22z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Pencil";
const Pencil = memo(themed(Icon));
export {
  Pencil
};
//# sourceMappingURL=pencil.js.map
